import styled from 'styled-components';
import { MailIcon } from 'lucide-react';

export const ResendEmailButton = styled(MailIcon)`
	cursor: pointer;
`;
